import { UTM_PARAMETER_PREFIX } from '../../constants/route'

export function isUTMSearchParam(param) {
  return param.toLowerCase().startsWith(UTM_PARAMETER_PREFIX)
}
